export class AvailabilityBlock {
    public id = -1;
    public name = '';
    public start_time = null;
    public end_date = null;
    public end_time = '';
    public recurring = false;
    public frequency = 'daily';
    public booking_id = -1;
    public type_of_block = 'free';
    blockout_title = '';
    recurring_week_days = [];
}



// WEBPACK FOOTER //
// ./src/app/shared/model/availability-block.entity.ts